import { useCallback, useState } from 'react';
import { List } from 'immutable';

// hooks / apis
import useDebounce from 'helpers/hooks/useDebounce';
import { useUserQuery } from 'api/account';

// material-ui
import Grid from '@material-ui/core/Grid';

// components
import ListCard from 'components/ListCard';
import SystemAdminItem from './components/SystemAdminItem';

// icons
import PeopleIcon from '@material-ui/icons/People';

const SystemAdminsTable = () => {
  const [searchValue, setSearchValue] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const debouncedSearch = useDebounce(searchValue, 600);

  const {
    data: { users: systemAdmins = [], total, hasNextPage } = {},
    isFetching,
  } = useUserQuery({
    isSystemAdmin: true,
    search: debouncedSearch,
    page: currentPage,
  });

  const handleChangeSystemAdminList = () => {
    setSearchValue('');
    setCurrentPage(1);
  };

  const items = List(
    systemAdmins.map((user: User) => (
      <SystemAdminItem
        key={user.id}
        user={user}
        handleChangeSystemAdminList={handleChangeSystemAdminList}
      />
    ))
  );

  const handlePageChange = useCallback(
    (page: number) => setCurrentPage(page),
    []
  );

  const onSystemAdminsSearchChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setSearchValue(event.target.value);
    },
    []
  );

  return (
    <Grid item xs={12}>
      <ListCard
        headerIcon={PeopleIcon}
        searchValue={searchValue}
        onSearchChange={onSystemAdminsSearchChange}
        items={items}
        loading={isFetching}
        paginationProps={{
          disableNextPage: !hasNextPage,
          onPageChange: handlePageChange,
          loading: isFetching,
          items: List(systemAdmins),
          total,
        }}
        searchLabel='Search System Admins'
        searchPlaceholder='Enter name or surname'
        subtitle='Manage system admins'
        title='System Admins'
      />
    </Grid>
  );
};

export default SystemAdminsTable;
